// Ch94 · FIXTURE slots and posts, so the calendar and its legend are visible.
//
// 🔴 EVERY ROW HERE IS INVENTED. Nothing has ever been scheduled or posted by
// this system — content_posts is 0 on production. These exist because a
// calendar with no entries reads as dead, and the dashed-vs-filled distinction
// and the type legend cannot be reviewed against the mock if nothing is on it.

import type { ScheduledPost, PublishedPost } from "../../../lib/postingCalendar";

/** Days relative to today, so the pack never depends on the date it was shot. */
const at = (dayOffset: number, hour: number, minute = 0): string => {
  const d = new Date();
  d.setDate(d.getDate() + dayOffset);
  d.setHours(hour, minute, 0, 0);
  return d.toISOString();
};

export const FIXTURE_SCHEDULED: ScheduledPost[] = [
  {
    reviewId: "slot-1",
    scheduledFor: at(2, 9, 0),
    subject: "The Grace Residences — tour",
    template: "property_tour",
  },
  {
    reviewId: "slot-2",
    scheduledFor: at(4, 18, 30),
    subject: "The Hadley — tour",
    template: "property_tour",
  },
  {
    reviewId: "slot-3",
    scheduledFor: at(6, 12, 0),
    subject: "How the free locator works",
    template: "service_explainer",
  },
];

export const FIXTURE_POSTED: PublishedPost[] = [
  {
    reviewId: "post-1",
    postedAt: at(-5, 9, 0),
    subject: "The Juniper — tour",
    template: "property_tour",
  },
  {
    reviewId: "post-2",
    postedAt: at(-2, 9, 0),
    subject: "What $3,000 gets you",
    template: "url-phone-social",
  },
];
